<div class="growth-content">
  <app-card
    [heading]="medianSalaryHeading"
    [tooltip]="salaryTooltip"
    (infoHover)="onSalaryInfoHover()"
  >
    <div class="flex-column">
      <p class="salary">{{ formattedMedianSalary }}</p>
      <!-- <p class="location">Update Location ></p> -->
    </div>
  </app-card>
  <app-card
    [heading]="jobGrowthHeading"
    [tooltip]="growthTooltip"
    (infoHover)="onGrowthInfoHover()"
  >
    <div class="growth-div">
      <p class="growth-rate">{{ jobGrowthPercentage }}</p>
      <div class="growth-avg-div">
        <p class="growth-avg-text">{{ growthStatement }}</p>
        <div class="growth-bars">
          @for (bar of growthBars; track $index) {
            <div class="growth-bar" [class.filled]="bar"></div>
          }
        </div>
      </div>
    </div>
  </app-card>
</div>
